import { useStacklineTheme } from '@stackline/ui';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import HoverTooltip from 'src/components/BeaconV2Components/HoverTooltip/HoverTooltip';
import { getFormattedMetricDateLabel } from 'src/components/BeaconV2Components/SplineChart/SplineChart';
import { formatMetric } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { ComparisonPeriod, useComparisonPeriod } from 'src/utils/Hooks';

const useAtlasV2MultipleIndexHooks = () => {
  const theme = useStacklineTheme();
  const comparisonPeriod = useComparisonPeriod();

  return (defaultProps) => {
    const { splinePreviewProps } = defaultProps;

    splinePreviewProps.renderCustomTooltip = ({ primaryPoint, secondaryPoint, percentChange, weekId }) => {
      return ReactDOMServer.renderToStaticMarkup(
        <HoverTooltip
          theme={theme}
          title={`Week ${weekId % 100}`}
          primaryColor={(primaryPoint.color as string) || theme.colors.primary}
          primaryMetric={`${formatMetric(primaryPoint.y, METRICTYPE.MULTIPLE, {
            decimalPlaces: 2,
            showFullValue: false,
            showNegative: true
          })}x`}
          primaryMetricLabel={getFormattedMetricDateLabel(
            weekId,
            undefined,
            primaryPoint.series.index === 2 && comparisonPeriod === ComparisonPeriod.PRIOR_YEAR
          )}
          change={
            percentChange !== undefined
              ? `${formatMetric(Math.abs(percentChange), METRICTYPE.PERCENT, { decimalPlaces: 2 })}`
              : undefined
          } // get rid of negative sign if there is one
          rawChange={percentChange}
          secondaryMetric={
            secondaryPoint
              ? `${formatMetric(secondaryPoint.y, METRICTYPE.MULTIPLE, {
                  decimalPlaces: 2,
                  showFullValue: false,
                  showNegative: true
                })}x`
              : ''
          }
          secondaryMetricLabel={getFormattedMetricDateLabel(
            weekId,
            undefined,
            comparisonPeriod === ComparisonPeriod.PRIOR_YEAR
          )}
          secondaryColor={secondaryPoint ? (secondaryPoint.color as string) : theme.colors.primaryLight}
        />
      );
    };

    return defaultProps;
  };
};

export default useAtlasV2MultipleIndexHooks;
